import { useId } from 'react';
import { useServices } from 'hooks/useServices';
import { FlowButton } from 'components/ui/flow-button';
import { isRetiredServicesDestination } from 'lib/servicesPlacement';
import './ServiceCatalog.css';

const number = index => String(index + 1).padStart(2, '0');

export default function ServiceCatalog() {
  const state = useServices('services');
  const entries = state.data?.filter(item => !isRetiredServicesDestination(item.path)) || [];

  if (!entries.length) return <section id="core-service-areas" className="services-collection-state" aria-busy={state.loading || undefined}>
    <div className="site-content-shell">
      <p role="status">{state.loading ? 'Loading services…' : state.error
        ? "We couldn't load the services. Please try again, or contact us about the support you need."
        : 'No services are listed here yet. Contact us to discuss the work your company needs help with.'}</p>
      {!state.loading && <div className="site-hero-ctas mt-6 flex flex-wrap gap-4">
        <FlowButton onClick={state.retry}>Try again</FlowButton>
        <FlowButton to="/#contact">Contact Magellan</FlowButton>
      </div>}
    </div>
  </section>;

  return <ServiceSelector catalogLinks={entries} />;
}

export function ServiceSelector({ catalogLinks }) {
  const id = useId();

  return <section id="core-service-areas" className="services-editorial" aria-labelledby="services-catalog-title" data-testid="services-catalog">
    <div className="site-content-shell">
      <header className="services-editorial-heading">
        <p>Core service areas</p>
        <h2 id="services-catalog-title">Find staff, reviews and software for your operation.</h2>
      </header>
      <div className="services-editorial-entries">
        {catalogLinks.map((item, index) => {
          const hasScope = item.deliverables?.length > 0;
          const titleId = `${id}-service-${index}`;
          const scopeId = `${titleId}-scope`;

          return <article key={item.id} className={`services-editorial-row${item.kind === 'link' ? ' services-editorial-row--navigation' : ''}`}
            data-service-id={item.id} aria-labelledby={titleId}>
            <span className="services-editorial-number" aria-hidden="true">{number(index)}</span>
            <div className="services-editorial-identity">
              <h3 id={titleId} className="services-editorial-title">{item.title}</h3>
              {item.headline && <p className="services-editorial-headline">{item.headline}</p>}
            </div>
            <div className="services-editorial-body">
              {item.description && <p className="services-editorial-description">{item.description}</p>}
              {item.context && <p className="services-editorial-context">{item.context}</p>}
              {hasScope && <div className="services-editorial-scope" aria-labelledby={scopeId}>
                <h4 id={scopeId}>Service scope</h4>
                <p className="services-editorial-helper">Your written offer sets out the work and fees.</p>
                <ul className="services-editorial-deliverables">{item.deliverables.map(text => <li key={text}>{text}</li>)}</ul>
              </div>}
              <FlowButton to={item.path} className="services-editorial-link">{item.cta}</FlowButton>
            </div>
          </article>;
        })}
      </div>
    </div>
  </section>;
}
